import { MORTGAGE_PROVIDERS } from '../../constants/mortgage-providers'

export default {
  mortgageProviders: MORTGAGE_PROVIDERS,
}
